module.exports = __webpack_public_path__ + "img/curlapp.0ca12c21.jpg";